__turbopack_context__.v({
  "action": "empty-state-module__jyZMva__action",
  "description": "empty-state-module__jyZMva__description",
  "empty": "empty-state-module__jyZMva__empty",
  "icon": "empty-state-module__jyZMva__icon",
  "title": "empty-state-module__jyZMva__title",
});
